var map = {
	"./1.jpg": "./src/assets/1.jpg",
	"./10.jpg": "./src/assets/10.jpg",
	"./11.jpg": "./src/assets/11.jpg",
	"./12.jpg": "./src/assets/12.jpg",
	"./13.jpg": "./src/assets/13.jpg",
	"./14.jpg": "./src/assets/14.jpg",
	"./15.jpg": "./src/assets/15.jpg",
	"./16.jpg": "./src/assets/16.jpg",
	"./17.jpg": "./src/assets/17.jpg",
	"./18.jpg": "./src/assets/18.jpg",
	"./19.jpg": "./src/assets/19.jpg",
	"./2.jpg": "./src/assets/2.jpg",
	"./20.jpg": "./src/assets/20.jpg",
	"./21.jpg": "./src/assets/21.jpg",
	"./22.jpg": "./src/assets/22.jpg",
	"./23.jpg": "./src/assets/23.jpg",
	"./24.jpg": "./src/assets/24.jpg",
	"./3.jpg": "./src/assets/3.jpg",
	"./4.jpg": "./src/assets/4.jpg",
	"./5.jpg": "./src/assets/5.jpg",
	"./6.jpg": "./src/assets/6.jpg",
	"./7.jpg": "./src/assets/7.jpg",
	"./8.jpg": "./src/assets/8.jpg",
	"./9.jpg": "./src/assets/9.jpg",
	"./ApplicationPermissionModel1.png": "./src/assets/ApplicationPermissionModel1.png",
	"./ApplicationPermissionModel2.png": "./src/assets/ApplicationPermissionModel2.png",
	"./AuthCodeFlow.png": "./src/assets/AuthCodeFlow.png",
	"./ClientCredentialFlow.png": "./src/assets/ClientCredentialFlow.png",
	"./DelegatedPermissionModel.png": "./src/assets/DelegatedPermissionModel.png",
	"./json.png": "./src/assets/json.png",
	"./openapi-1.svg": "./src/assets/openapi-1.svg",
	"./postman.png": "./src/assets/postman.png",
	"./santa.png": "./src/assets/santa.png",
	"./schaeffler-logo.svg": "./src/assets/schaeffler-logo.svg",
	"./yaml.png": "./src/assets/yaml.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";